import { Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRef } from "react";

interface FileUploadButtonProps {
  onFileSelect: (files: FileList) => void;
  disabled?: boolean;
}

const ACCEPTED_FILE_TYPES = [
  '.pdf',
  '.docx',
  '.txt',
  '.md',
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  '.gif',
  '.csv',
  '.xlsx',
  '.json',
  '.xml'
].join(',');

export const FileUploadButton = ({ onFileSelect, disabled }: FileUploadButtonProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      onFileSelect(files);
      // Reset input para permitir selecionar o mesmo arquivo novamente
      e.target.value = '';
    }
  };

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={handleClick}
        disabled={disabled}
        className="shrink-0"
      >
        <Paperclip className="h-5 w-5" />
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept={ACCEPTED_FILE_TYPES}
        onChange={handleFileChange}
        className="hidden"
      />
    </>
  );
};
